import {Injectable} from '@angular/core';
import {map, Observable, shareReplay} from 'rxjs';
import {ApiService} from './api.service';

interface StageDto {
  stage: string;
}

@Injectable({
  providedIn: 'root',
})
export class StageService {

  private _stage$?: Observable<string>;

  constructor(private readonly api: ApiService) {
  }

  getStage(): Observable<string> {
    this._stage$ ??= this.api.get<StageDto>('/api/stage').pipe(
        map(response => this.mapStageToTranslationKey(response.stage)),
        shareReplay({bufferSize: 1, refCount: false})
    );
    return this._stage$;
  }

  private mapStageToTranslationKey(stage: string): string {
    switch (stage) {
      case 'RELEASE':
        return 'RoamingUI.stageRelease';
      case 'PROD':
        return 'RoamingUI.stageProduction';
      case 'TEST':
        return 'RoamingUI.stageTest';
      case 'LOCAL':
        return 'RoamingUI.stageLocal';
      default:
        return 'RoamingUI.stageDefault';
    }
  }
}
